import React from 'react';
import { Button, LoadingButton } from './buttons';
import { useTranslate } from '../hooks';

export function ModalActions({
  isSubmitting,
  className,
  onSubmit,
  onCancel,
  disabled,
  title,
  cancelButtonProps,
  applyButtonProps,
  applyDraftProps,
  isDraftSubmitting,
  onDraftSubmit,
  driftDisabled,
  draft,
  cancel = false,
  submit = false
}) {
  const { translate } = useTranslate();

  return (
    <div className={`flex justify-end w-full gap-x-4 ${className}`}>
      {!cancel && (
        <Button
          className={`outline-btn ${cancelButtonProps?.className}`}
          onClick={onCancel}
        >
          {translate('Cancel')}
        </Button>
      )}
      {draft && (
        <LoadingButton
          className={`outline-btn bg-transparent hover:bg-yellow-500 hover:text-white hover:border-transparent  ${applyDraftProps?.className}`}
          isLoading={isDraftSubmitting}
          onClick={onDraftSubmit}
          disabled={driftDisabled}
        >
          {translate('Save Draft')}
        </LoadingButton>
      )}
      {!submit && (
        <LoadingButton
          className={`primary-btn ${applyButtonProps?.className}`}
          isLoading={isSubmitting}
          onClick={onSubmit}
          disabled={disabled}
        >
          {title || translate('Submit')}
        </LoadingButton>
      )}
    </div>
  );
}
